module.exports = __webpack_public_path__ + "img/atm_logo.30849448.jpeg";